import React from "react";

type IContent = {
  children: React.ReactNode;
};

const Content: React.FC<IContent> = ({ children }) => {
  return <main className="overflow-x-hidden w-full p-9">{children}</main>;
};

export default Content;
